import { jsx as _jsx } from "react/jsx-runtime";
import { BASE_TABLE_TD_ALIGN } from './BaseTableTD.constants';
import { BaseTableTDRoot } from './BaseTableTD.styled';
// Component.
// -----------------------------------------------------------------------------
export const BaseTableTD = ({ align = BASE_TABLE_TD_ALIGN, children, size, type, className }) => (_jsx(BaseTableTDRoot, { align: align, size: size, type: type, className: className, children: children }));
//# sourceMappingURL=BaseTableTD.js.map